import { useState, useEffect } from "react";

import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";
import MobileLanding from "./Landing/MobileLanding";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import useFetch from "Hooks/useFetch.js";
import IsError from "Components/RequestHandler/IsError";

const ServiceMainPage = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("services");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero />
        <Landing data={data} />
        <MobileLanding data={data} />
      </main>
    );
  }
};

export default ServiceMainPage;
